var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#FCA94C","height":"20vh","width":"100vw"}},[_c('img',{staticClass:"sushi-header-mobile",attrs:{"src":require("../../../assets/images/sushiHub/homeBannerMobile.svg"),"alt":"image"}})])
}]

export { render, staticRenderFns }